import Footer from "../Components/Footer";
import Header from "../Components/Header";
import SmallHero from "../Components/SmallHero";
import MatchFilter from "./MatchFilter";

export default function MyContacts () {

    document.body.classList.add('live');

    return (
        <div className="base-box fixed scroll-box" id="page-top">
        <Header />
        <div className="base-item" >
            <SmallHero />
        </div>
        <main className="main-content">
            <MatchFilter type="contacts" />
        </main>
        <Footer />
        </div>
    );
}
